import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { ProcessedNotificationsTableDefinitionZod } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaLoanRequestResolver_GetProcessedNotifications = z.array(ProcessedNotificationsTableDefinitionZod);

export type SchemaLoanRequestResolver_GetProcessedNotifications = z.infer<
    typeof schemaLoanRequestResolver_GetProcessedNotifications
>;

export type LoanRequestResolver_GetProcessedNotifications = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetProcessedNotifications
>;
